<template>
    <div
        class="h-44 relative rounded-b-3xl overflow-hidden"
        style="
            height: 11rem;
            background-image: url('/assets/dashboard/top-image.jpg');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
        "
    >
        <div class="container mx-auto px-4 h-full relative z-10">
            <div class="mt-5">
                <div>
                    <h1 class="text-white text-2xl font-bold mb-5">
                        Chúc bạn một ngày làm việc hiệu quả!
                    </h1>
                    <p class="text-white text-xl">
                        Cùng chốt nhiều đơn hôm nay nhé
                    </p>
                </div>
            </div>
        </div>
        <div class="absolute flex items-center gap-4 right-5 top-2 z-50">
            <div
                @click="router.push('/packages/create')"
                class="px-3 py-1 text-lg text-[#1e40af] rounded-lg shadow-xl font-semibold cursor-pointer bg-[#fbd415] hover:bg-yellow-100 hover:text-indigo-700"
            >
                Lên đơn
            </div>

            <div
                @click="router.push('/packages/upload-excel')"
                class="border-2 border-green-600 px-3 py-1 text-lg text-[#fff] rounded-lg shadow-xl font-semibold cursor-pointer hover:bg-blue-600"
            >
                Lên đơn Excel
            </div>

            <div
                class="flex items-center cursor-pointer"
                @click="router.push('/user/profile')"
            >
                <div
                    class="h-10 w-10 rounded-full mx-auto bg-no-repeat bg-center bg-cover mr-2"
                    :style="{
                        backgroundImage:
                            'url(' + userAvatar?.photo?.data?.url + ')',
                    }"
                ></div>
                <div class="">
                    <p class="text font-semibold text-white">
                        {{ user?.name }}
                    </p>
                    <p class="text-xs text-gray-200">{{ user?.shop_code }}</p>
                </div>
            </div>

            <div @click="logout" class="cursor-pointer">
                <span class="text-white">
                    <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path></svg>
                </span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import userApi from "../../api/user";
import { useStore } from "vuex";
import Langselector from "../Sidebar/Langselector.vue";
import { useRouter } from "vue-router";
const store = useStore();
const router = useRouter();

const user = ref({
    name: "",
    shop_code: "",
    photo: {
        data: {
            url: "",
        },
    },
});
const getInfo = async function () {
    const { data } = await userApi.getUserInfo(
        `?include=photo,default_store,shop`
    );
    user.value = data.data;
    await store.commit("user/SET_USER_INFORMATION", data.data);
};
const userAvatar = computed(() => store.state?.user?.userInfo || user.value);

onMounted(() => {
    if (localStorage.getItem("access_token")) {
        getInfo();
    }
});

async function logout() {
            await store.dispatch("logout");
            await router.push({ name: "Login" });
        }

</script>
